import React from 'react'

// Artwork matches assets/map-zoom-in.svg, map-zoom-out.svg, map-compass.svg, and
// map-locate.svg. Displayed at the 20px slot from the corner-control design.
const iconProps = {
  width: 20,
  height: 20,
  viewBox: '0 0 24 24',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true as const,
  focusable: false as const,
}

export const MapZoomInIcon: React.FC = () => (
  <svg {...iconProps}>
    <path
      d="M11 18V13H6C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11H11V6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44772 13 6V11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H13V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18Z"
      fill="currentColor"
    />
  </svg>
)

export const MapZoomOutIcon: React.FC = () => (
  <svg {...iconProps}>
    <path
      d="M18 11C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H6C5.44772 13 5 12.5523 5 12C5 11.4477 5.44772 11 6 11H18Z"
      fill="currentColor"
    />
  </svg>
)

export const MapCompassIcon: React.FC = () => (
  <svg {...iconProps}>
    <path
      d="M11.1054 5.55272C11.2747 5.21394 11.6208 4.99961 11.9996 4.99961C12.3783 4.99963 12.7245 5.21396 12.8938 5.55272L15.8942 11.5528C16.0347 11.8341 16.0347 12.165 15.8942 12.4463L12.8938 18.4464C12.7245 18.7851 12.3783 18.9995 11.9996 18.9995C11.6208 18.9995 11.2747 18.7852 11.1054 18.4464L8.10499 12.4463L8.05872 12.3393C7.96632 12.0835 7.98199 11.7991 8.10499 11.5528L11.1054 5.55272ZM10.1165 11.9995L11.9989 15.763L13.8799 11.9995L11.9989 8.23614L10.1165 11.9995Z"
      fill="currentColor"
    />
    <path
      d="M21 12C21 7.02944 16.9705 3 12 3C7.02943 3 3 7.02943 3 12C3 16.9705 7.02944 21 12 21C16.9705 21 21 16.9705 21 12ZM23 12C23 18.0751 18.0751 23 12 23C5.92486 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92486 23 12Z"
      fill="currentColor"
    />
  </svg>
)

export const MapLocateIcon: React.FC = () => (
  <svg {...iconProps}>
    <path
      d="M18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18C15.3137 18 18 15.3137 18 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58173 20 4 16.4183 4 12C4 7.58173 7.58173 4 12 4C16.4183 4 20 7.58173 20 12Z"
      fill="currentColor"
    />
    <path
      d="M11 21L11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17L13 21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21Z"
      fill="currentColor"
    />
    <path
      d="M7 11C7.55228 11 8 11.4477 8 12C8 12.5523 7.55228 13 7 13H3C2.44772 13 2 12.5523 2 12C2 11.4477 2.44772 11 3 11H7Z"
      fill="currentColor"
    />
    <path
      d="M11 7L11 3C11 2.44772 11.4477 2 12 2C12.5523 2 13 2.44772 13 3L13 7C13 7.55228 12.5523 8 12 8C11.4477 8 11 7.55228 11 7Z"
      fill="currentColor"
    />
    <path
      d="M21 11C21.5523 11 22 11.4477 22 12C22 12.5523 21.5523 13 21 13L17 13C16.4477 13 16 12.5523 16 12C16 11.4477 16.4477 11 17 11L21 11Z"
      fill="currentColor"
    />
  </svg>
)
